<template>
  <div class="skill_group_monitor" :style="screenHeight">
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <div class="demo-split">
        <div class="demo-split-pane" style="float:left;width:30%;">
          <div class="ztree" id="skillGroupTree"></div>
        </div>
        <div  class="demo-split-pane" style="float:right;width:70%;border-left:1px solid #eeeeee;">
          <div class="fixed_table">
            <div class="monitor_time">
              <div class="fixed_title">当前技能组号码:{{queueNumber}}</div>
              <Select v-model="autoRefreshTime" filterable @on-change="autoRefreshMonitor" title="自动刷新时间">
                <Option v-for="item in autoRefreshList" :value="item.time" :key="item.id">{{ item.name }}</Option>
              </Select>
              <span style="color: red;float: right;margin-right: 10px" title="刷新倒计时">{{countdownTime}}</span>
            </div>
            <div class="table_head">
              <table>
                <tr>
                  <th class="font_style_set" style="width:5%;">状态</th>
                  <th class="font_style_set" style="width:15%;">主叫号码</th>
                  <th class="font_style_set" style="width:15%;">被叫号码</th>
                  <th class="font_style_set" style="width:10%;">呼叫类型</th>
                  <th class="font_style_set" style="width:10%;">客户类型</th>
                </tr>
              </table>
            </div>
            <div class="footer_style" :style="tableHeight">
              <table class="table_head_footer">
                <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                  <td  style="width:5%;">{{item.status}}</td>
                  <td  style="width:15%;">{{item.caller}}</td>
                  <td  style="width:15%;">{{item.callee}}</td>
                  <td  style="width:10%;">{{item.callType}}</td>
                  <td  style="width:10%;">{{item.customerType}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "SkillGroupMonitor",
    mixins:[publicFunClass],
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        split: 0.3,
        spinShow:false,
        Interval:'',
        currentBusid:'',
        queueNumber:'',
        inspectTreeData:[{"id":2,"pId":0,"name":"技能组","open":true,"isParent":true,"busid":"-1"}],
        tableHeight:{height:''},
        screenHeight:{height:''},
        infoTableList:[],
        skillList:'',
        countdownTime:0,
        roleList:JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo"))
      }
    },
    methods:{
      autoRefresh:function(){
        let that=this;
        let signinStatus=localStorage.getItem("signinStatus");
        if(signinStatus=='0'){
          this.$Message.info("请先签入,再查询数据");
          return false;
        }
        
        if(!that.currentBusid){
          that.currentBusid = that.queueNumber;
        }
        this.$emit("getSkill","get_customer_of_queue","queueNumLstStr",that.currentBusid);
      },
      initSearch:function (event) {
        let signinStatus=localStorage.getItem("signinStatus");
        if(signinStatus=='0'){
          return false;
        }
        if(!event){
          return false;
        }
        this.infoTableList=[];
        let customer_status =event.customer_status.split(",");
        let customer_num =event.customer_num.split(",");
        let callee_num =event.callcenter_num.split(",");
        let call_type =event.call_type.split(",");
        let customer_type =event.customer_type.split(",");
        let queueNumList =event.queue_num.split(",");
        this.queueNumber=event.queueNumLstStr;
        for (let i=0;i<queueNumList.length;i++){
          let status='';
          let customerType="";
          let callType="";
          let caller=customer_num[i];//主叫号码
          let callee=callee_num[i];//被叫号码
          if (customer_status[i] == "Waiting"){
              status= "等待";
          }
          if (customer_status[i] == "Trying"){
              status= "振铃";
          }
          if (customer_type[i] == "1"){
             customerType= "普通客户";
          }
          if (customer_type[i] == "2"){
             customerType= "VIP客户";
          }
          if (customer_type[i] == "3"){
              customerType= "重进入客户";
          }
          if (call_type[i] == "0"){
              callType= "呼入";
          }
          if (call_type[i] == "1"){
              callType= "预测式呼出";
          }
          let param={
            status:status,
            customerType:customerType,
            callType:callType,
            caller:caller,
            callee:callee
          };
          if(status || customerType || callType || caller || callee){
            this.infoTableList.push(param);
          }
        }
      },
      //设备树初始化
      initSkillGroupTree:function (queueList) {
        let count=200;
        for (let i=0;i<queueList.length;i++){
          let name=queueList[i].name;
          let num=queueList[i].queueNum;
          let treeStr={
            id:count++,
            pId:2,
            name:name,
            open:false,
            isParent:false,
            busid:num
          };
          this.inspectTreeData.push(treeStr);
          this.queueNumber += (num+",");
        }
        this.queueNumber = this.queueNumber.substring(0,this.queueNumber.lastIndexOf(','));
        let that=this;
        let setting = {
          view: {
            dblClickExpand: false,
            showLine: true,
            selectedMulti: false
          },
          data: {
            simpleData: {
              enable:true,
              idKey: "id",
              pIdKey: "pId",
              rootPId: ""
            }
          },
          callback: {
            onClick: zTreeOnClick
          }
        };
        function zTreeOnClick(event,treeId,treeNode) {
          if(treeNode.pId!=0){
            if(!treeNode.busid){
              that.$Message.info("该监控下,没有数据");
              return false;
            }
            that.currentBusid=treeNode.busid;
            that.$emit("getSkill","get_customer_of_queue","queueNumLstStr",treeNode.busid);
          }
        }
        let zNodes =this.inspectTreeData;
        if (zNodes){
          $(document).ready(function(){
            $.fn.zTree.init($("#skillGroupTree"), setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
          });
        }
      },
      monitorSkillData:function (event) {
        let retCode=event.retCode;
        if(retCode!='0'){
          this.$Modal.info({
            title:'提示',
            content:event.reason
          });
          return false;
        }
        let eventMethod=event.method;
        if(eventMethod=="get_customer_of_queue"){//获取技能组监控信息
          this.initSearch(event);
        }
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(92);
      this.tableHeight.height=this.mountHeight(230);
      let signinStatus=localStorage.getItem("signinStatus");
      if(signinStatus=='0'){
        this.$Message.info("请先签入,再查询数据");
        return false;
      }
      let that=this;
      let param={
        journalType:"监控管理=>通话监控=>技能组监控查询",
        menuId:"null"
      };
      this.spinShow=true;
      this.$http.post("monitor/toRightRang.json",param) .then(function (res) {
        let result = res.data.flag;
        that.spinShow=false;
        if (result != "666") {
          that.$Message.info(res.data.msg);
          return false;
        }
        let queueList=res.data.obj.skillList;
        that.initSkillGroupTree(queueList);
      });
    },
    destroyed(){
      clearInterval(this.Interval);
      this.autoRefreshTime="0";
      this.autoRefreshMonitor();
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='7_2-3' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
        }
        if(this.pageCode=='7_2-3'){
          this.autoRefreshTime=this.historyRefreshTime;
          this.autoRefreshMonitor();
        }
        if(this.pageCode!='7_2-3'){
          clearInterval(this.Interval);
          this.autoRefreshTime="0";
          this.countdownTime="0";
        }
      }
    }
  }
</script>

<style scoped>
  .demo-split{
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MonitorManage/SkillGroupMonitor.vue